import { Link } from 'react-router-dom';

const warningSigns = [
  { icon: 'ri-money-dollar-circle-line', text: 'Apostar más de lo que puedes permitirte perder' },
  { icon: 'ri-refresh-line', text: 'Intentar recuperar pérdidas apostando más (chasing)' },
  { icon: 'ri-eye-off-line', text: 'Ocultar tus apuestas a familia o amigos' },
  { icon: 'ri-emotion-unhappy-line', text: 'Sentirte ansioso o irritable cuando no apuestas' },
  { icon: 'ri-bank-card-line', text: 'Pedir dinero prestado para apostar' },
  { icon: 'ri-briefcase-line', text: 'Descuidar trabajo, estudios o responsabilidades' },
  { icon: 'ri-arrow-up-line', text: 'Necesitar apostar cantidades mayores para sentir emoción' },
  { icon: 'ri-time-line', text: 'Pasar más tiempo apostando del que tenías planeado' },
];

const myths = [
  {
    myth: '"Llevo una racha mala, pronto me tocará ganar"',
    reality: 'Cada apuesta es independiente. Las rachas pasadas no afectan a los resultados futuros. Esto se llama la falacia del jugador.',
  },
  {
    myth: '"Tengo un sistema infalible para ganar"',
    reality: 'No existe ningún sistema que garantice ganancias a largo plazo. Las casas tienen ventaja matemática en todos sus mercados.',
  },
  {
    myth: '"Puedo dejar de apostar cuando quiera"',
    reality: 'El juego problemático es una adicción reconocida. Si crees que puedes parar cuando quieras, intenta no apostar durante 30 días.',
  },
  {
    myth: '"Solo apuesto dinero que me sobra"',
    reality: 'El dinero "que sobra" tiene un coste de oportunidad. Además, el umbral de lo que "sobra" tiende a aumentar con el tiempo.',
  },
];

export default function SignsSection() {
  return (
    <section id="senales" className="py-20 bg-[#080a0f]">
      <div className="max-w-[1440px] mx-auto px-6">
        {/* Warning signs */}
        <div className="flex items-start gap-4 mb-10">
          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#ef4444]/10 border border-[#ef4444]/20 flex-shrink-0">
            <i className="ri-alarm-warning-line text-[#ef4444] text-xl"></i>
          </div>
          <div>
            <p className="text-[#ef4444] text-xs font-semibold uppercase tracking-widest mb-1">Reconoce las señales</p>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2" style={{ fontFamily: "'Syne', sans-serif" }}>
              Señales de Alerta
            </h2>
            <p className="text-[#a8b2c1] text-sm max-w-2xl">
              Reconocer estas señales a tiempo es fundamental. Si te identificas con varias de ellas, considera buscar ayuda.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-16">
          {warningSigns.map((s) => (
            <div key={s.text} className="flex items-start gap-3 p-4 bg-[#0d0f14] border border-[#1e2028] rounded-xl hover:border-[#ef4444]/20 transition-colors">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#ef4444]/10 flex-shrink-0">
                <i className={`${s.icon} text-[#ef4444] text-sm`}></i>
              </div>
              <p className="text-[#a8b2c1] text-xs leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>

        {/* Myths */}
        <div className="flex items-start gap-4 mb-8">
          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#8b5cf6]/10 border border-[#8b5cf6]/20 flex-shrink-0">
            <i className="ri-lightbulb-line text-[#8b5cf6] text-xl"></i>
          </div>
          <div>
            <p className="text-[#8b5cf6] text-xs font-semibold uppercase tracking-widest mb-1">Desmontando mitos</p>
            <h2 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: "'Syne', sans-serif" }}>
              Mitos del Apostador
            </h2>
            <p className="text-[#a8b2c1] text-sm max-w-2xl">
              Estas creencias erróneas son muy comunes y pueden llevar a decisiones perjudiciales.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-14">
          {myths.map((m) => (
            <div key={m.myth} className="bg-[#0d0f14] border border-[#1e2028] rounded-xl overflow-hidden">
              <div className="p-4 border-b border-[#1e2028] flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#ef4444]/10 flex-shrink-0 mt-0.5">
                  <i className="ri-close-line text-[#ef4444] text-xs"></i>
                </div>
                <p className="text-[#a8b2c1] text-sm italic">{m.myth}</p>
              </div>
              <div className="p-4 flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#00e87a]/10 flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-[#00e87a] text-xs"></i>
                </div>
                <p className="text-[#a8b2c1] text-sm leading-relaxed">{m.reality}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Emergency CTA */}
        <div className="relative overflow-hidden rounded-2xl bg-[#0d0f14] border border-[#ef4444]/20 p-8">
          <div className="absolute top-0 right-0 w-80 h-80 bg-[#ef4444]/5 rounded-full -translate-y-1/2 translate-x-1/2"></div>
          <div className="relative flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <div className="flex items-center gap-2 mb-3">
                <div className="w-2 h-2 rounded-full bg-[#ef4444] animate-pulse"></div>
                <span className="text-[#ef4444] text-xs font-semibold uppercase tracking-widest">Ayuda inmediata</span>
              </div>
              <h3 className="text-white font-bold text-2xl mb-2" style={{ fontFamily: "'Syne', sans-serif" }}>
                ¿Necesitas hablar con alguien ahora?
              </h3>
              <p className="text-[#a8b2c1] text-sm max-w-lg">
                El teléfono de FEJAR está disponible las 24 horas, los 7 días de la semana. Es completamente gratuito y confidencial. No tienes que dar tu nombre.
              </p>
            </div>
            <div className="flex flex-col items-center gap-3 flex-shrink-0">
              <a
                href="tel:900200225"
                className="flex items-center gap-3 px-8 py-4 bg-[#ef4444] text-white text-lg font-bold rounded-xl hover:bg-[#dc2626] transition-colors cursor-pointer whitespace-nowrap"
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-phone-fill text-lg"></i>
                </div>
                900 200 225
              </a>
              <p className="text-[#6b7280] text-xs">Gratuito · Confidencial · 24h</p>
            </div>
          </div>
        </div>

        {/* Link to test */}
        <div className="mt-8 text-center">
          <p className="text-[#6b7280] text-sm mb-3">¿No estás seguro si tienes un problema?</p>
          <Link
            to="#test"
            onClick={() => document.getElementById('test')?.scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center gap-2 px-5 py-2.5 border border-[#2a2d3a] text-[#a8b2c1] text-sm font-medium rounded-lg hover:border-[#06b6d4]/40 hover:text-white transition-colors cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-questionnaire-line text-sm"></i>
            </div>
            Hacer el test de autoevaluación
          </Link>
        </div>
      </div>
    </section>
  );
}
